import React from 'react';
import Hero from './Hero';
import Title from './Title';
import Subtitle from './Subtitle';
import H1 from './H1';
import H1Alt from './H1Alt';
import H2 from './H2';
import H2Alt from './H2Alt';
import H3 from './H3';
import H4 from './H4';
import H5 from './H5';
import H6 from './H6';
import Body from './Body';
import Paragraph from './Paragraph';
import Small from './Small';
import SmallUppercase from './SmallUppercase';
import SmallAlt from './SmallAlt';

const AccentHero = props => <Hero color="accent" {...props} />;
const AccentTitle = props => <Title color="accent" {...props} />;
const AccentSubtitle = props => <Subtitle color="accent" {...props} />;
const AccentH1 = props => <H1 color="accent" {...props} />;
const AccentH1Alt = props => <H1Alt color="accent" {...props} />;
const AccentH2 = props => <H2 color="accent" {...props} />;
const AccentH2Alt = props => <H2Alt color="accent" {...props} />;
const AccentH3 = props => <H3 color="accent" {...props} />;
const AccentH4 = props => <H4 color="accent" {...props} />;
const AccentH5 = props => <H5 color="accent" {...props} />;
const AccentH6 = props => <H6 color="accent" {...props} />;
const AccentBody = props => <Body color="accent" {...props} />;
const AccentParagraph = props => <Paragraph color="accent" {...props} />;
const AccentSmall = props => <Small color="accent" {...props} />;
const AccentSmallUppercase = props => (
  <SmallUppercase color="accent" {...props} />
);
const AccentSmallAlt = props => <SmallAlt color="accent" {...props} />;

const SecondaryHero = props => <Hero color="secondary" {...props} />;
const SecondaryTitle = props => <Title color="secondary" {...props} />;
const SecondarySubtitle = props => <Subtitle color="secondary" {...props} />;
const SecondaryH1 = props => <H1 color="secondary" {...props} />;
const SecondaryH1Alt = props => <H1Alt color="secondary" {...props} />;
const SecondaryH2 = props => <H2 color="secondary" {...props} />;
const SecondaryH2Alt = props => <H2Alt color="secondary" {...props} />;
const SecondaryH3 = props => <H3 color="secondary" {...props} />;
const SecondaryH4 = props => <H4 color="secondary" {...props} />;
const SecondaryH5 = props => <H5 color="secondary" {...props} />;
const SecondaryH6 = props => <H6 color="secondary" {...props} />;
const SecondaryBody = props => <Body color="secondary" {...props} />;
const SecondaryParagraph = props => <Paragraph color="secondary" {...props} />;
const SecondarySmall = props => <Small color="secondary" {...props} />;
const SecondarySmallUppercase = props => (
  <SmallUppercase color="secondary" {...props} />
);
const SecondarySmallAlt = props => <SmallAlt color="secondary" {...props} />;

const DangerText = props => <Body color="danger" {...props} />;
const SuccessText = props => <Body color="success" {...props} />;

export {
  Hero,
  Title,
  Subtitle,
  H1,
  H1Alt,
  H2,
  H2Alt,
  H3,
  H4,
  H5,
  H6,
  Body,
  Paragraph,
  Small,
  SmallUppercase,
  SmallAlt,
  AccentHero,
  AccentTitle,
  AccentSubtitle,
  AccentH1,
  AccentH1Alt,
  AccentH2,
  AccentH2Alt,
  AccentH3,
  AccentH4,
  AccentH5,
  AccentH6,
  AccentBody,
  AccentParagraph,
  AccentSmall,
  AccentSmallUppercase,
  AccentSmallAlt,
  SecondaryHero,
  SecondaryTitle,
  SecondarySubtitle,
  SecondaryH1,
  SecondaryH1Alt,
  SecondaryH2,
  SecondaryH2Alt,
  SecondaryH3,
  SecondaryH4,
  SecondaryH5,
  SecondaryH6,
  SecondaryBody,
  SecondaryParagraph,
  SecondarySmall,
  SecondarySmallUppercase,
  SecondarySmallAlt,
  DangerText,
  SuccessText
};
